import { OP_SEARCH_ITEMS } from '@doda/common/src/constants/searchItems';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { PositionListType } from 'types/kodawari';
import { HooksArgument } from 'components/SearchSideBar/types';
import { POSITION_CODE_AND_QUERY } from 'constants/searchCondition';
import { getInitialIdList } from '../getInitialIdList';

/**
 * 仕事内容の初期状態を生成
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.queries クエリパラメータ
 * @param param.jobCountData 求人件数
 * @returns 仕事内容の初期状態
 */
export const createInitialPositionList = ({
  savedSearchCondition,
  featuredSearchCondition,
  queries,
  jobCountData,
}: HooksArgument) => {
  const idList = getInitialIdList({
    savedSearchCondition,
    featuredSearchCondition,
    queries,
  });

  const initialData: PositionListType[] = [
    {
      id: OP_SEARCH_ITEMS.overseasBusinessTrip.id,
      name: OP_SEARCH_ITEMS.overseasBusinessTrip.name,
      isChecked: idList.some(
        (query) => query === OP_SEARCH_ITEMS.overseasBusinessTrip.id
      ),
      value: POSITION_CODE_AND_QUERY.OVERSEAS_BUSINESS_TRIP.code,
      jobCount: findJobCount(
        jobCountData.positionsList,
        POSITION_CODE_AND_QUERY.OVERSEAS_BUSINESS_TRIP.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.manager.id,
      name: OP_SEARCH_ITEMS.manager.name,
      isChecked: idList.some((query) => query === OP_SEARCH_ITEMS.manager.id),
      value: POSITION_CODE_AND_QUERY.MANAGER.code,
      jobCount: findJobCount(
        jobCountData.positionsList,
        POSITION_CODE_AND_QUERY.MANAGER.code
      ),
    },
  ];

  return initialData;
};
